module.exports = __webpack_public_path__ + "components/flag/static/square/ws-254ec8090a4c8deda0c8d2bca2257d66.svg";